import { useState } from 'react';
import { Card, CardContent, CircularProgress, Icon, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import { motion } from 'framer-motion';

// local imports
import { useCustomerContactUsListService, useQuery } from 'app/hooks/services';
import { EnvDefaults } from 'app/utils';
import ContactUsDetail from './contact-us-detail';
import { CustomDataTable } from 'app/components/organisms/table';
import { FilterCustomerContactUs } from 'app/components/organisms/filter-forms';
import { CustomModal } from 'app/components/molecules';

const tableQueries = {
  limit: 25,
  skip: 0,
  orderBy: 'created_at',
  sortBy: 'desc',
  name: '',
  surname: '',
  start_date: '',
  end_date: ''
};

const CustomerContactUsList = () => {
  const [open, setOpen] = useState(false);
  const [contactFormId, setContactFormId] = useState(null);

  // opens detail modal and set contact form id
  const openModal = id => {
    setOpen(true);
    setContactFormId(id);
  };

  // close detail modal and clear selected contact form id
  const closeModal = () => setOpen(false);

  // end user - customer contact us forms service connection
  const { queries, handleFilterChange, handlePageChange, handleSort, isFilteringRef } =
    useQuery(tableQueries);

  const { service, handleRefresh } = useCustomerContactUsListService(
    queries,
    isFilteringRef,
    openModal
  );

  return (
    <>
      <motion.div initial={{ scale: 0, opacity: 0.2 }} animate={{ scale: 1, opacity: 1 }}>
        {/* Filter form */}
        <Card className="mb-16" elevation={4}>
          <CardContent>
            <div className="flex items-center">
              <Icon>filter_list</Icon>
              <Typography variant="subtitle1" className="text-gray-700 font-semibold mx-8">
                Filtrele
              </Typography>
              {isFilteringRef.current && (
                <CircularProgress color="secondary" size={22} thickness={6} />
              )}
            </div>

            <Formik initialValues={EnvDefaults.filterCustomerContactUsDefaults}>
              <FilterCustomerContactUs handleChange={handleFilterChange} />
            </Formik>
          </CardContent>
        </Card>

        <Card elevation={3}>
          <CardContent>
            <CustomDataTable
              defaultSortId={queries?.orderBy}
              defaultDirection={queries?.sortBy}
              service={service}
              queries={queries}
              handlePageChange={handlePageChange}
              handleChange={handleFilterChange}
              handleSort={handleSort}
              handleRefreshTable={handleRefresh}
            />
          </CardContent>
        </Card>

        {/* Contact Us Detail Modal */}
        <CustomModal noAction open={open} onClose={closeModal} title="Detay Görüntüle">
          <ContactUsDetail formId={contactFormId} />
        </CustomModal>
      </motion.div>
    </>
  );
};

export default CustomerContactUsList;
